/** "Dr. Meera Iyer", without doubling a "Dr" the name already carries ("Dr. Anitha", "Dr Kumar"). */
export const doctorName = (fullName: string): string => {
  const name = fullName.trim();
  return /^dr\.?\s/i.test(name) ? name : `Dr. ${name}`;
};
